"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderDetailsClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const ORDER_DETAILS_BASE_URL = process.env.ORDER_DETAILS_BASE_URL;
const ORDER_DETAILS_BASIC_AUTH_USER = process.env.ORDER_DETAILS_BASIC_AUTH_USER;
const ORDER_DETAILS_BASIC_AUTH_PASSWORD = process.env.ORDER_DETAILS_BASIC_AUTH_PASSWORD;
class OrderDetailsClient extends base_client_1.ApiBasicAuthClient {
    constructor(config = {
        baseURL: ORDER_DETAILS_BASE_URL,
        basicAuthUser: ORDER_DETAILS_BASIC_AUTH_USER,
        basicAuthPassword: ORDER_DETAILS_BASIC_AUTH_PASSWORD,
    }) {
        super(config);
        if (!config.baseURL) {
            commons_logs_1.log.warn("ORDER_DETAILS_BASE_URL environment variable is not set");
        }
        if (!config.basicAuthUser || !config.basicAuthPassword) {
            commons_logs_1.log.warn("ORDER_DETAILS_BASIC_AUTH_USER and/or ORDER_DETAILS_BASIC_AUTH_PASSWORD environment variable is not set");
        }
    }
    async queueOrderDetails(orderId) {
        try {
            return await this.post(`/v1/order-details/${orderId}`, {});
        }
        catch (error) {
            throw (0, base_client_1.mapError)(error);
        }
    }
}
exports.OrderDetailsClient = OrderDetailsClient;
//# sourceMappingURL=OrderDetailsClient.js.map